import { MusicRowDataProps } from '@modules/entertainment/models/music.models';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { LiveTvActionParams } from '@modules/entertainment/pages/live-tv/store/live-tv.model.ts';

export interface MusicActionParams {
  data?: MusicRowDataProps;
  id?: any;
  state?: any;
  handleClose?: () => void;
}
export interface MusicState extends CallStateMethods {
  callState: CallStateEnum;
  genreCallState: CallStateEnum;
  genreList: any[];
  createRow: (params: MusicActionParams) => void;
  editRow: (params: MusicActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose: () => void;
  }) => void;
  createGenre: (params: { data: any; handleClose?: () => void }) => void;
  editGenre: (params: { data: any; id: any; handleClose?: () => void }) => void;
  deleteGenre: (params: LiveTvActionParams) => void;
  getGenreList: () => void;
  isGenreLoading: () => boolean;
  isGenreLoaded: () => boolean;
  isGenreError: () => boolean;
}
interface MusicStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
  createGenre: 'createGenre';
  editGenre: 'editGenre';
  deleteGenre: 'deleteGenre';
  getGenreList: 'getGenreList';
  isGenreLoading: 'isGenreLoading';
  isGenreLoaded: 'isGenreLoaded';
  isGenreError: 'isGenreError';
}

export const MUSIC_INITIAL_STATE: Omit<MusicStateMethods, keyof MusicState> = {
  genreList: [],
  callState: CallStateEnum.Init,
  genreCallState: CallStateEnum.Init
};
